import { Routes } from '@angular/router';

const routes_404_white_label: Routes = [
  {
    path: '',
    loadChildren: () => import('@white-label/routes/home/home.module').then((m) => m.HomeWhiteLabelModule),
  },
  {
    path: '404',
    loadChildren: () => import('@white-label/routes/pagina-404/pagina-404.module').then((m) => m.Pagina404Module),
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];

const routes_app_white_label: Routes = [
  {
    path: 'legal/coltefinanciera',
    loadComponent: () =>
      import('@white-label/routes/terminos-legales/pages/terms-conditions.component').then(
        (m) => m.TermsConditionsWhiteLabel,
      ),
  },
];

const routes_tubo_white_label: Routes = [
  {
    path: 'login',
    loadChildren: () => import('@white-label/routes/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'mis-procesos',
    loadChildren: () => import('@white-label/routes/mis-procesos/mis-procesos.module').then((m) => m.MisProcesosModule),
  },
  {
    path: 'validar-identidad',
    loadChildren: () =>
      import('@white-label/routes/validar-identidad/validar-identidad.module').then((m) => m.ValidarIdentidadModule),
  },
  {
    path: 'confirmar-datos-truora',
    loadChildren: () =>
      import('@white-label/routes/confirmar-datos-truora/confirmar-datos-truora.module').then(
        (m) => m.ConfirmarDatosTruoraModule,
      ),
  },
  {
    path: 'v2/preguntas-cdturbo',
    loadChildren: () =>
      import('@white-label/routes/preguntas-cdturbo/preguntas-cdturbo.module').then((m) => m.PreguntasCdturboModule),
  },

  {
    path: 'consulta-en-listas',
    loadChildren: () =>
      import('@white-label/routes/consulta-en-listas/consulta-en-listas.module').then((m) => m.ConsultaEnListasModule),
  },
  {
    path: 'sube-tus-documentos',
    loadChildren: () =>
      import('@white-label/routes/sube-tus-documentos/sube-tus-documentos.module').then(
        (m) => m.SubeTusDocumentosModule,
      ),
  },
  {
    path: 'asegura-tu-tasa',
    loadChildren: () =>
      import('@white-label/routes/asegura-tu-tasa/asegura-tu-tasa.module').then((m) => m.AseguraTuTasaModule),
  },

  {
    path: 'no-podemos-continuar-con-tu-proceso',
    loadChildren: () =>
      import('@white-label/routes/no-podemos-continuar-con-tu-proceso/no-podemos-continuar-con-tu-proceso.module').then(
        (m) => m.NoPodemosContinuarConTuProcesoModule,
      ),
  },
  {
    path: 'firma-los-documentos-en-fisico',
    loadChildren: () =>
      import('@white-label/routes/no-podemos-continuar-con-tu-proceso/no-podemos-continuar-con-tu-proceso.module').then(
        (m) => m.NoPodemosContinuarConTuProcesoModule,
      ),
  },
  {
    path: 'bloqueo-temporal',
    loadChildren: () =>
      import('@white-label/routes/bloqueo-temporal/bloqueo-temporal.module').then((m) => m.BloqueoTemporalModule),
  },
  {
    path: 'te-contactaremos',
    loadChildren: () =>
      import('@white-label/routes/te-contactaremos/te-contactaremos.module').then((m) => m.TeContactaremosModule),
  },
  {
    path: 'transfiere-el-dinero',
    loadChildren: () =>
      import('@white-label/routes/transfiere-el-dinero/transfiere-el-dinero.module').then(
        (m) => m.TransfiereElDineroModule,
      ),
  },
  {
    path: 'cdt-completado',
    loadChildren: () =>
      import('@white-label/routes/cdt-completado/cdt-completado.module').then((m) => m.CdtCompletadoModule),
  },
];

export class routingColtefinanciera {
  /* White Label */
  public static routes: Routes = [...routes_app_white_label, ...routes_tubo_white_label, ...routes_404_white_label];
}
